exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "div.sign-up-bottom{width:100%;height:250px;padding:0;margin:0;background-image:url(\"https://placeholder.pics/svg/1400x267/46FFFC\");display:flex}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/dist/cjs.js??ref--1-3!./components/baby-club/sign-up-bottom/index.scss
// module id = 748
// module chunks = 0